import * as ActionTypes from 'hellospa/common/constants/condor/action-types';
import * as NoticeTypes from 'hellospa/common/constants/condor/notice-types';

/**
 * Shows a notice of the specified type with the specified
 * message.
 *
 * @param {string} message
 * @param {Symbol} [type]
 * @returns {Object}
 */
export function showNotice(message, type) {
  return {
    type: ActionTypes.SHOW_NOTICE,
    payload: {
      type: type || NoticeTypes.INFO,
      message,
    },
  };
}

/**
 * Shows a success notice with the specified message.
 *
 * @param {string} message
 * @returns {Object}
 */
export function showSuccessNotice(message) {
  return showNotice(message, NoticeTypes.SUCCESS);
}

/**
 * Shows an info notice with the specified message.
 *
 * @param {string} message
 * @returns {Object}
 */
export function showInfoNotice(message) {
  return showNotice(message, NoticeTypes.INFO);
}

/**
 * Shows a warning notice with the specified message.
 *
 * @param {string} message
 * @returns {Object}
 */
export function showWarningNotice(message) {
  return showNotice(message, NoticeTypes.WARNING);
}

/**
 * Shows an error notice with the specified message.
 *
 * @param {string} message
 * @returns {Object}
 */
export function showErrorNotice(message) {
  return showNotice(message, NoticeTypes.ERROR);
}

/**
 * Closes a notice with the given id.
 *
 * @param {string} id
 * @returns {Object}
 */
export function closeNotice(id) {
  return {
    type: ActionTypes.CLOSE_NOTICE,
    payload: {
      id,
    },
  };
}

/**
 * Clears all notices.
 *
 * @returns {Object}
 */
export function clearNotices() {
  return {
    type: ActionTypes.CLEAR_NOTICES,
  };
}
